import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14.831 14.155"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#141414",
      d: "M7.414 0a1.36 1.36 0 0 0-1.213.75L6.2.752 4.643 3.889l-3.483.506c-.25.035-.482.14-.676.302H.483A1.35 1.35 0 0 0 .41 6.701v.002l2.518 2.438-.594 3.443c-.182 1.06 1.014 1.924 1.965 1.426l3.115-1.63 3.115 1.63.002.002c.951.496 2.148-.367 1.965-1.428l-.594-3.443 2.516-2.438c.182-.175.312-.399.373-.644v-.002c.06-.245.05-.503-.027-.742v-.002a1.36 1.36 0 0 0-1.098-.918l-3.479-.506L8.631.752 8.629.75A1.35 1.35 0 0 0 7.414 0"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star"}) } }